module.exports = "https://qp-assets.quero.com/assets/images/queropago-white.svg?de713220a878935df8c16425c75f90df";